"use strict";
import TOPAZ_ID_ICON from "assets/images/logo.png";
import GNOSIS_ICON from "assets/images/gnosis.png";
import BINANCE_ICON from "assets/wallets/binance-icon.svg";
import COINBASE_ICON from "assets/wallets/coinbase-icon.svg";
import METAMASK_ICON from "assets/wallets/metamask-icon.svg";
import WALLET_CONNECT_ICON from "assets/wallets/walletconnect-icon.svg";
import { PRIVY_CONNECTOR_ID } from "components/Web3Provider/privy/privyConnector";
import { atomWithStorage, useAtomValue } from "jotai/utils";
import { CONNECTION_PROVIDER_IDS } from "constants/web3";
export const CONNECTOR_ICON_OVERRIDE_MAP = {
  [CONNECTION_PROVIDER_IDS.METAMASK_RDNS]: METAMASK_ICON,
  [CONNECTION_PROVIDER_IDS.COINBASE_SDK_CONNECTOR_ID]: COINBASE_ICON,
  [CONNECTION_PROVIDER_IDS.WALLET_CONNECT_CONNECTOR_ID]: WALLET_CONNECT_ICON,
  [CONNECTION_PROVIDER_IDS.BINANCE_W3W_CONNECTOR_ID]: BINANCE_ICON,
  [CONNECTION_PROVIDER_IDS.SAFE_CONNECTOR_ID]: GNOSIS_ICON,
  // Privy embedded wallet (Topaz ID) — the injected target has no icon, so the connected-state
  // WalletIcon would otherwise render a broken image.
  [PRIVY_CONNECTOR_ID]: TOPAZ_ID_ICON
};
export const recentConnectorIdAtom = atomWithStorage("recentConnectorId", void 0);
export function useRecentConnectorId() {
  return useAtomValue(recentConnectorIdAtom);
}
